export enum EAddressType {
    LOQATE = 'LOQATE',
    GETADDRESSIO = 'GETADDRESSIO',
    MANUAL = 'MANUAL',
}
